import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { Box, useMediaQuery } from "@mui/material";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import colors from "../../../theme";

const dayLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const monthLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const BarGraphEnergy = ({ view, chartData }) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width:1000px)");
  const xAxisLabel = () => {
    switch (view) {
      case "daily":
        return "Hours";
      case "weekly":
        return "Days";
      case "monthly":
        return "Dates";
      case "yearly":
        return "Months";
      default:
        return "Hours";
    }
  };

  const formatWeeklyChartData = () => {
    return chartData.map((item, index) => ({
      ...item,
      time: dayLabels[index],
    }));
  };

  const formatYearlyChartData = () => {
    return chartData.map((item, index) => ({
      ...item,
      time: monthLabels[index],
    }));
  };

  const formatChartData = () => {
    if (view === "weekly") {
      return formatWeeklyChartData();
    } else if (view === "yearly") {
      return formatYearlyChartData();
    } else if (view === "daily") {
      return chartData;
    } else if (view === "monthly") {
      return chartData;
    }
    return chartData;
  };

  const formattedChartData = formatChartData();

  const maxYValue = chartData.every((item) => item.energy === 0)
    ? 1
    : Math.max(...chartData.map((item) => item.energy)) < 1
      ? 1
      : Math.max(...chartData.map((item) => item.energy));

  const chartSetting = {
    yAxis: [
      {
        label: "Energy (kWh)",
        min: 0,
        max: maxYValue,
      },
    ],
    sx: {
      [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
        transform: "translateX(-30px)",
      },
    },
  };

  return (
    <>
      {chartData.length > 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            overflow: "auto",
            width: "100%",
          }}
        >
          <BarChart
            margin={{ left: 80 }}
            xAxis={[
              {
                scaleType: "band",
                data: formattedChartData.map((item) => item.time),
                label: xAxisLabel(),
              },
            ]}
            series={[
              {
                data: formattedChartData.map((item) => item.energy),
                color: colors.secondary,
              },
            ]}
            width={isSmallScreen ? 375 : isMediumScreen ? 575 : 850}
            height={isSmallScreen ? 275 : 350}
            {...chartSetting}
            axisHighlight={isSmallScreen ? { x: "none", y: "none" } : {}}
          />
        </Box>
      ) : (
        <Box
          sx={{
            height: { xs: "50vh", xl: "35vh" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            color: "black",
          }}
        >
          No data to Display
        </Box>
      )}
    </>
  );
};

export default BarGraphEnergy;
